type fieldDescriptionProps = {
    description: string;
}

export default function FieldDescription({ description }: fieldDescriptionProps){
    return(
        <span className="input-description-container">
            <p className = "description-text" >
                EXPLICATION
                <br />
                { description }
            </p>
        </span>
    )
}

